import React from 'react';

import HeaderNavComponent from '../header/HeaderNavComponent';
import FooterComponent from '../footer/FooterComponent';

export const PrimaryTemplate = props => {
    return (
        <div className="template template-primary flex-container-v">
            <HeaderNavComponent hideNav={props.hideNav} hideSearch={props.hideSearch} />
            {props.children}
            <FooterComponent />
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/template/PrimaryTemplate.js